/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Rendicontazione } from './rendicontazione';
import { StoricoCostoPasto } from './storicoCostoPasto';
import { StoricoPastiUsufruiti } from './storicoPastiUsufruiti';

export interface Portafogli { 
    id?: string;
    annoDiRiferimento?: string;
    residuo?: number;
    costoPasto?: number;
    costoContributo?: number;
    saldoIniziale?: number;
    pastiResidui?: number;
    pastiUsufruiti?: number;
    pastiConsumatiInEsenzione?: number;
    rendicontazioni?: Array<Rendicontazione>;
    storicoCostiPasto?: Array<StoricoCostoPasto>;
    storicoPastiUsufruiti?: Array<StoricoPastiUsufruiti>;
    created_at?: Date;
    updated_at?: Date;
}